import { Card, H5 } from "@blueprintjs/core";
import { AvailableTemplate } from "src/models/AvailableTemplates";
import { Instruction } from "src/models/Instruction";
import SetInstructionsTree from "./SetInstructionsTree";

import { useMemo, useState } from "react";
import { useProjects } from "src/hooks/useProjects";
import SetProcessInputs from "./SetProcessInputs";

import "./SetInstructionsTree.scss";

type Props = {
    template: AvailableTemplate;

    formRef: any;
};

export default function SetInstructions({ template, formRef }: Props) {
    const [selectedInstId] = useState(template.instructions[0].projectId);
    const [projects] = useProjects();
    const project = useMemo(() => projects.find(p => p.projectId === selectedInstId), [projects, selectedInstId]);

    return (
        <div className="run-instructions">
            <div className="instruction-panels">
                <Card>
                    <H5>{`Current Instruction: ${project?.name}`}</H5>
                    <SetProcessInputs template={template} formRef={formRef} />
                </Card>
            </div>
            <div className="instruction-tree">
                <SetInstructionsTree instructions={template.instructions as Array<Instruction>} />
            </div>
        </div>
    );
}
